<template>
  <div id="diagnosticsForm">
    <div class="mb-4">
      <worker-data @change:employee="changedEmployee" />
    </div>

    <template v-if="showInformation">
      <worker-information :id="id_selected_employee" />

      <b-row class="mt-5 mb-5">
        <b-col cols="auto" class="mr-auto">
          <strong>Diagnósticos Registrados</strong>
        </b-col>
        <b-col cols="auto">
          <button
            class="button-primary"
            @click.prevent="
              $router.push({
                name: 'sveDiagnosticsRegisterCreate',
                params: { employee_id: id_selected_employee, is_edit: true },
              })
            "
          >
            <span
              >Agregar nuevo diagnóstico
              <img class="pl-1 mb-1" src="@/assets/images/icons/add.svg"
            /></span>
          </button>
        </b-col>
      </b-row>

      <data-table
        class="mt-3"
        :id="id_selected_employee"
        :diagnostics="diagnostics"
        :isLoaging="isLoaging"
        @deleteItem="deleteItemDiagnostic"
      />

      <!-- PCL -->
      <div v-if="diagnostics.length > 0">
        <b-row class="mt-5 mb-5">
          <b-col cols="auto" class="mr-auto">
            <strong>PCLs</strong>
          </b-col>
          <b-col cols="auto">
            <button class="button-primary" @click.prevent="createPCL">
              <span
                >Agregar nuevo PCL
                <img class="pl-1 mb-1" src="@/assets/images/icons/add.svg"
              /></span>
            </button>
          </b-col>
        </b-row>
        <b-row class="mt-5 mb-5">
          <b-col cols="12" class="mb-4">
            <strong>Perdida de Capacidad Laboral</strong>
          </b-col>
          <b-col cols="12">
            <TableListPcl
              :pcls="pcls"
              :isLoaging="isLoaging2"
              :employeeId="id_selected_employee"
              @deleteItem="deleteItemPCL"
            />
          </b-col>
        </b-row>
      </div>
    </template>

    <template v-else>
      <b-col cols="12" sm="6" class="mt-5 text-center">
        <img
          class="centerImg1"
          src="@/assets/modules/health-tracker/img/pill.svg"
          width="50%"
          alt="logo"
        />
      </b-col>
    </template>
    <!-- 4 MODAL Confirmación-->
    <modal-confirm
      :loading="loading3"
      @deleteItem="deleteRecord"
      :confirmation="confirmation"
    />

    <!-- 3 MODAL PROCESO EXITOSO  -->
    <modal-success :messageModal="messageModal" />

    <!-- 4 MODAL PROCESO FALLIDO -->
    <modal-error :error="error" />
  </div>
</template>

<script>
import {
  getDiagnostics,
  getPCLs,
  deletePCL,
  deleteDiagnostic,
} from "@/services/health-tracker/diagnostic/service";
import TableListPcl from "./components/pcl/TableListPcl.vue";
import ModalSuccess from "@/views/SVE/modals/ModalSuccess.vue";
import ModalError from "@/views/SVE/modals/ModalError.vue";
import ModalConfirm from "@/views/SVE/modals/ModalConfirm.vue";

export default {
  name: "diagnosticsForm",
  components: {
    WorkerData: () =>
      import(
        "@/components/Modules/HealthTracker/V2/Common/WorkerData/WorkerData.vue"
      ),
    WorkerInformation: () =>
      import(
        "@/components/Modules/HealthTracker/V2/Common/WorkerInformation/WorkerInformation.vue"
      ),
    DataTable: () =>
      import(
        "@/components/Modules/HealthTracker/V2/DiagnosticLog/DataTable/DataTable.vue"
      ),
    TableListPcl,
    ModalSuccess,
    ModalError,
    ModalConfirm,
  },
  data: () => ({
    id_selected_employee: 0,
    diagnostics: [],
    pcls: [],
    isLoaging: false,
    isLoaging2: false,
    loading3: false,
    messageModal: "",
    confirmation: {},
    error: {},
    idPclDelete: null,
    idDiagnostic: null,
    typeDelete: null,
  }),
  computed: {
    showInformation() {
      return this.id_selected_employee > 0;
    },
  },
  methods: {
    changedEmployee({ id }) {
      const me = this;
      me.id_selected_employee = id;
      me.$router.push({
        name: "sve",
        params: {
          category: "diagnostics-register",
          type: id ? id : null,
        },
      });
      me.loadDiagnostics();
    },
    createPCL() {
      const me = this;
      me.$router.push({
        name: "addPCL",
        params: { employee_id: me.id_selected_employee, is_edit: true },
      });
    },
    async loadDiagnostics() {
      const me = this;
      me.isLoaging = true;
      me.diagnostics = [];
      try {
        const { data } = await getDiagnostics(me.id_selected_employee);
        me.diagnostics = data?.data;
        if (me.diagnostics.length > 0) me.loadPcls();
      } catch (error) {
        console.log(error);
      } finally {
        me.isLoaging = false;
      }
    },
    async loadPcls() {
      const me = this;
      me.isLoaging2 = true;
      me.pcls = [];
      try {
        const { data } = await getPCLs(me.id_selected_employee);
        data?.forEach((x) => {
          x.diagnostics2 = [];
          x.diagnostics_ids?.forEach((y) => {
            const record = me.diagnostics.find((z) => z.id == y);
            if (record) {
              x.diagnostics2.push({
                id: record.id,
                name: record.code_name,
              });
            }
          })
        });
        me.pcls = data;
      } catch (error) {
        console.log(error);
      } finally {
        me.isLoaging2 = false;
      }
    },
    deleteItemPCL(id) {
      const me = this;
      me.idPclDelete = id;
      me.typeDelete = "pcl";
      me.confirmation = {
        type: "delete",
        text: `¿Estás seguro de eliminar esta PCL?`,
      };
      me.$bvModal.show("modal-confirm");
    },
    async deletePCL() {
      const me = this;
      try {
        me.loading3 = true;
        await deletePCL(me.idPclDelete);
        me.idPclDelete = null;
        me.messageModal = `PCL Eliminado`;
        me.$bvModal.show("modal-success");
        me.$bvModal.hide("modal-confirm");
        me.loadPcls();
      } catch (error) {
        me.error = error;
        me.$bvModal.hide("modal-confirm");
        me.$bvModal.show("modal-fail");
      } finally {
        me.loading3 = false;
      }
    },
    deleteItemDiagnostic(id) {
      const me = this;
      me.idDiagnostic = id;
      me.typeDelete = "diagnostic";
      me.confirmation = {
        type: "delete",
        text: `¿Estás seguro de eliminar este Diagnóstico?`,
      };
      me.$bvModal.show("modal-confirm");
    },
    async deleteDiagnostic() {
      const me = this;
      try {
        me.loading3 = true;
        await deleteDiagnostic(me.idDiagnostic);
        me.idDiagnostic = null;
        me.messageModal = `Diagnóstico Eliminado`;
        me.$bvModal.show("modal-success");
        me.$bvModal.hide("modal-confirm");
        me.loadDiagnostics();
      } catch (error) {
        me.error = error;
        me.$bvModal.hide("modal-confirm");
        me.$bvModal.show("modal-fail");
      } finally {
        me.loading3 = false;
      }
    },
    deleteRecord() {
      const me = this;
      me.typeDelete == "diagnostic" ? me.deleteDiagnostic() : me.deletePCL();
    },
  },
};
</script>

<style lang="scss" />
